/**
 * Not nginx's 20M: the backend sends photos to the vision model as a base64 data
 * URL, and OpenAI caps one image at 20 MB *encoded* — measured decimal, tested:
 * 14.9 MiB raw encodes to 20.83 MB and 400s. Base64 costs 4 bytes per 3, putting
 * the raw ceiling at 15,000,000 bytes; 14 MiB keeps ~0.4 MB spare for the
 * data-URL prefix and the prompt. Don't raise it — over the line
 * `POST /v1/files` still succeeds and `POST /v1/mealinsight` fails with a
 * generic `CANNOT_GENERATE_INSIGHTS`, which reads as anything but a size limit.
 */
export const FILE_UPLOAD_MEGABYTE_LIMIT = 14;
export const UPLOAD_PAYLOAD_LIMIT_BINARY =
  FILE_UPLOAD_MEGABYTE_LIMIT * 1024 * 1024;
export const UserEligibleMinimumAge = 18;
export const FILE_CACHE_LIFETIME = 12000;
